import { render } from "./Slider1.vue?vue&type=template&id=356e541f&scoped=true"
import script from "./Slider1.vue?vue&type=script&lang=js"
export * from "./Slider1.vue?vue&type=script&lang=js"

import "./Slider1.vue?vue&type=style&index=0&id=356e541f&scoped=true&lang=css"

import exportComponent from "/Users/peter/projects/BhubCollege/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356e541f"]])

export default __exports__